'use client';
import cn from 'classnames';
import styles from './QuestionsBlock.module.scss';
import { ProductDetailedType, QuestionType } from '@/types';
import { Loader } from '@/atoms/Loader';
import { useEffect, useState } from 'react';
import { Button } from '@/atoms/Button';
import { EmptyReviewBlock } from '@/components/EmptyReviewBlock';
import { QuestionItem } from '@/components/QuestionItem';
import { Modal } from '@/atoms/Modal';
import { BottomDrawer } from '@/atoms/BottomDrawer';
import {
  selectShowLeaveQuestionModal,
  setShowAuthModal,
  setShowLeaveQuestionModal,
} from '@/store';
import { useDispatch, useSelector } from 'react-redux';
import { useAdaptiveLayout } from '@/hooks/useAdaptiveLayout';
import { LeaveQuestionForm } from '@/modules/Product/LeaveQuestionForm';
import { getTokens } from '@/services';
import { useBodyScrollLock } from '@/hooks/useBodyScrollLock';

type QuestionsBlockProps = {
  className?: string;
  items: QuestionType[];
  product: ProductDetailedType;
};

export function QuestionsBlock({
  className,
  items,
  product,
}: QuestionsBlockProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const [loading, setLoading] = useState(true);
  const showLeaveQuestionModal = useSelector(selectShowLeaveQuestionModal);
  const dispatch = useDispatch();
  const { isTablet } = useAdaptiveLayout();
  const { accessToken } = getTokens();
  useBodyScrollLock(showLeaveQuestionModal);

  const handleCloseLeaveQuestionModal = () => {
    dispatch(setShowLeaveQuestionModal(false));
  };

  const handleLeaveQuestion = () => {
    if (!accessToken) {
      dispatch(setShowAuthModal(true));
    } else {
      dispatch(setShowLeaveQuestionModal(true));
    }
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <div className={wrapperClassName}>
      <div className={styles.header}>
        <div />
        <div className={styles.button}>
          <Button
            variant="secondary"
            text="Задать вопрос"
            onClick={handleLeaveQuestion}
          />
        </div>
      </div>
      {loading && <Loader />}
      {items.length === 0 && !loading && (
        <EmptyReviewBlock text="Пока нет вопросов" />
      )}
      {items.length > 0 && !loading && (
        <div className={styles.list}>
          {items.map((question) => (
            <QuestionItem question={question} key={question.id} />
          ))}
        </div>
      )}
      <Modal
        showCloseButton={true}
        active={showLeaveQuestionModal && !isTablet}
        onClose={handleCloseLeaveQuestionModal}
      >
        <LeaveQuestionForm product={product} />
      </Modal>
      <BottomDrawer
        active={showLeaveQuestionModal && !!isTablet}
        onClose={handleCloseLeaveQuestionModal}
      >
        <LeaveQuestionForm product={product} />
      </BottomDrawer>
    </div>
  );
}
